import type { AbsenceRequestContextT } from './types'

export const INITIAL_VALUES: AbsenceRequestContextT = {
  showAbsencePlannerDrawer: false,
  setShowAbsencePlannerDrawer: (_show: boolean) => {},
}
